import axios from 'axios';

const responder = (idSolicitacao, negociacao) => axios.post(`/external/negociacoes/${idSolicitacao}`, negociacao);
const getNegociacoes = idSolicitacao => axios.get(`/external/negociacoes/${idSolicitacao}`);

export default {
  responder,
  getNegociacoes,
};
